import React, { createContext, useEffect, useState, useRef } from "react";
import { isNull } from "App/utils/helpers";
import { FORM_RESET_DETAIL, FORM_RESET_STATE_WMS_MT } from "../helpers";
import { WMS_FA_INPUT_MAINTENANCE } from "App/constants";
import { DEFAULT_SHOW_BUTTON_SUBMIT } from "App/constants";

export const FormContext = createContext();

export const FormProvider = ({ type = "create", children, data, menu }) => {
  const oldFormDataIMT = useRef(null);
  const [showModalBarang, setShowModalBarang] = useState(false);
  const [showModalVerifikasi, setShowModalVerifikasi] = useState(false);
  const [formData, setFormData] = useState(() => {
    if (isNull(data)) {
      return FORM_RESET_STATE_WMS_MT;
    } else {
      if (menu === WMS_FA_INPUT_MAINTENANCE) {
        oldFormDataIMT.current = data;
        return data;
      } else {
        if (isNull(oldFormDataIMT.current)) {
          return FORM_RESET_STATE_WMS_MT;
        } else {
          return oldFormDataIMT.current;
        }
      }
    }
  });

  const [validasi, setValidasi] = useState(false);
  const [filePDF, setFilePDF] = useState([]);
  const [detailMT, setDetailMT] = useState([]);
  const [listREQ, setListREQ] = useState([]);
  const [listDetail, setListDetail] = useState([]);
  const [formDetail, setFormDetail] = useState(FORM_RESET_DETAIL);
  const [listDetailWork, setListDetailWork] = useState([]);
  const [formDetailWork, setFormDetailWork] = useState([]);
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  // const [formData, setFormData] = useState(FORM_RESET_STATE_WMS_MT)
  useEffect(() => {
    if (isNull(data)) {
      setFormData(FORM_RESET_STATE_WMS_MT);
    } else {
      if (menu === WMS_FA_INPUT_MAINTENANCE) {
        oldFormDataIMT.current = data;
        setFormData(data);
      } else {
        if (isNull(oldFormDataIMT.current)) {
          setFormData(FORM_RESET_STATE_WMS_MT);
        } else {
          setFormData(oldFormDataIMT.current);
        }
      }
    }
  }, [data]); // eslint-disable-line
  return (
    <FormContext.Provider
      value={{
        formData,
        setFormData,
        listREQ,
        setListREQ,
        disabled,
        setDisabled,
        showModalBarang,
        setShowModalBarang,
        filePDF,
        setFilePDF,
        showModalVerifikasi,
        setShowModalVerifikasi,
        validasi,
        setValidasi,
        detailMT,
        setDetailMT,
        listDetail,
        setListDetail,
        formDetail,
        setFormDetail,
        listDetailWork,
        setListDetailWork,
        formDetailWork,
        setFormDetailWork,
      }}>
      {children}
    </FormContext.Provider>
  );
};
